import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TenantReportFile ( props ) {

    return <BasicCrudScreenType id="VwTenantReportFile" noExcel table="TenantReportFile" view="VwTenantReportFile" />

}

export default TenantReportFile;
